import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Filtro from "../../../cuentas/components/Filtro";
import FrmCheckout from "../netpay_form/FrmCheckout";

const defaultCredenciales = {
    public_key:"",
    secret_key:""
}

const CHECKOUT = (props) => {
    const { contratados } = useSelector(state => state.cuentas);
    const [ credenciales, setCredenciales ] = useState(defaultCredenciales);
    const [ device, setDevice ] = useState({});

    useEffect(()=>{
        contratados.forEach(element =>{
            if(element.tipoServicio === 'NETPAY_CHECKOUT'){
                setCredenciales( element.credenciales );
                setDevice( element );
            }
        })
    }, [contratados])

    return (
        <Box pt={1} m={1}>
            <Filtro bodyContent={ <FrmCheckout credenciales={credenciales} device={device } /> } title={"Llaves"} icon={ "fa-solid fa-key" } open={true} />
        </Box>
    );
}

export default CHECKOUT;